module.exports = __webpack_public_path__ + "img/biaoqian_matou.d7bb9ff2.png";